/* ─── Fluence Theme — Main JavaScript ─── */

document.addEventListener('DOMContentLoaded', () => {

  // ─── Wait for GSAP + Lenis to load ───
  const waitForLibs = setInterval(() => {
    if (typeof gsap !== 'undefined' && typeof Lenis !== 'undefined') {
      clearInterval(waitForLibs);
      initFluence();
    }
  }, 50);

});

function initFluence() {

  // ─── Lenis smooth scroll ───
  window.lenisInstance = new Lenis({ lerp: 0.08, smoothWheel: true });
  function raf(t) { window.lenisInstance.raf(t); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  // ─── GSAP + ScrollTrigger ───
  gsap.registerPlugin(ScrollTrigger);
  window.lenisInstance.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => { window.lenisInstance.raf(time * 1000); });
  gsap.ticker.lagSmoothing(0);

  // ─── Scroll progress bar ───
  gsap.to('#scroll-progress', {
    width: '100%', ease: 'none',
    scrollTrigger: { trigger: 'body', start: 'top top', end: 'bottom bottom', scrub: true }
  });

  // ─── GSAP reveal ───
  gsap.utils.toArray('.gsap-reveal').forEach(el => {
    const delay = parseFloat(el.dataset.delay || 0);
    gsap.fromTo(el,
      { y: 40, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out', delay,
        scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
      }
    );
  });

  // ─── Hero stagger (product pages) ───
  const productInfo = document.getElementById('product-info');
  if (productInfo) {
    gsap.fromTo(productInfo.children,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', stagger: 0.08, delay: 0.2 }
    );
  }
  const gallery = document.getElementById('product-gallery');
  if (gallery) {
    gsap.fromTo(gallery, { scale: 0.96, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.9, ease: 'power3.out', delay: 0.1 });
  }

  // ─── Mineral bars ───
  const mineralBarsSection = document.getElementById('mineral-bars');
  if (mineralBarsSection) {
    ScrollTrigger.create({
      trigger: mineralBarsSection,
      start: 'top 80%',
      onEnter: () => {
        document.querySelectorAll('.mineral-bar').forEach(bar => {
          bar.style.width = bar.dataset.width || '0%';
        });
      }
    });
  }

  // ─── Nav shadow on scroll ───
  window.addEventListener('scroll', () => {
    const nav = document.getElementById('main-nav');
    if (nav) nav.classList.toggle('shadow-sm', window.scrollY > 20);
  }, { passive: true });

  // ─── Mobile menu toggle ───
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('hidden');
      mobileToggle.textContent = mobileNav.classList.contains('hidden') ? 'menu' : 'close';
    });
  }

  // ─── Cart trigger ───
  const cartTrigger = document.getElementById('cart-trigger');
  if (cartTrigger) {
    cartTrigger.addEventListener('click', () => fluenceCart.open());
  }

  // ─── Product form: AJAX add to cart ───
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = parseInt(document.getElementById('variant-id').value);
      if (!variantId) return;

      const sellingPlanEl = document.getElementById('selling-plan-id');
      const sellingPlanId = sellingPlanEl && sellingPlanEl.value && !sellingPlanEl.disabled
        ? parseInt(sellingPlanEl.value) : null;

      const btn = document.getElementById('add-to-cart-btn');
      const originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span class="material-symbols-outlined text-[20px]">progress_activity</span> Adding...';

      await fluenceCart.add(variantId, 1, sellingPlanId);

      btn.innerHTML = '<span class="material-symbols-outlined text-[20px]">check</span> Added to Cart!';
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }, 2500);
    });
  }

  // ─── Qty buttons in cart drawer ───
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const key = btn.dataset.changeKey;
    const qty = parseInt(btn.dataset.qty);
    if (key) fluenceCart.updateQuantity(key, qty);
  });

  // ─── Variant selector (product pages) ───
  initVariantSelector();

  // ─── Subscription purchase type (nasal strips) ───
  initSubscriptionSelector();

}

// ─── Cart ───
window.fluenceCart = {
  drawer:  null,
  overlay: null,

  async add(variantId, quantity = 1, sellingPlanId = null) {
    const item = { id: variantId, quantity };
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (!res.ok) {
        const err = await res.json();
        alert(err.description || 'Could not add item to cart.');
        return;
      }
      await this.refresh();
      this.open();
    } catch (err) {
      console.error('Cart error:', err);
    }
  },

  async refresh() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update all count badges
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });

    // Update total
    const totalEl = document.getElementById('cart-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Update free shipping bar
    updateShippingBar(cart.total_price);

    // Re-render cart items
    const container = document.getElementById('cart-items');
    if (container) {
      if (cart.item_count === 0) {
        container.innerHTML = '<p class="text-center text-on-surface-variant py-12 font-body">Your cart is empty.</p>';
      } else {
        container.innerHTML = cart.items.map(item => `
          <div class="flex items-start gap-4 py-4 border-b border-outline-variant/20">
            <img src="${item.image}" alt="${item.title}" class="w-16 h-16 rounded-xl object-contain bg-surface-container-low flex-shrink-0"/>
            <div class="flex-1 min-w-0">
              <p class="font-headline font-bold text-sm leading-tight mb-1">${item.product_title}</p>
              ${item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null' ? `<p class="font-body text-xs text-on-surface-variant mb-1">${item.variant_title}</p>` : ''}
              ${item.selling_plan_allocation ? `<p class="font-body text-xs text-primary mb-1">${item.selling_plan_allocation.selling_plan.name}</p>` : ''}
              <div class="flex items-center gap-2 mt-2">
                <button data-change-key="${item.key}" data-qty="${item.quantity - 1}" class="qty-btn w-6 h-6 rounded-full bg-surface-container flex items-center justify-center text-sm font-bold hover:bg-surface-container-high transition-colors">−</button>
                <span class="font-body text-sm font-bold w-6 text-center">${item.quantity}</span>
                <button data-change-key="${item.key}" data-qty="${item.quantity + 1}" class="qty-btn w-6 h-6 rounded-full bg-surface-container flex items-center justify-center text-sm font-bold hover:bg-surface-container-high transition-colors">+</button>
                <span class="font-headline font-bold text-sm ml-auto">${formatMoney(item.final_line_price)}</span>
              </div>
            </div>
          </div>
        `).join('');
      }
    }

    return cart;
  },

  async updateQuantity(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await this.refresh();
  },

  open() {
    const drawer  = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer)  drawer.classList.add('open');
    if (overlay) overlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
  },

  close() {
    const drawer  = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer)  drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('visible');
    document.body.style.overflow = '';
  }
};

// ─── Money formatter ───
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ─── Free shipping progress bar ───
function updateShippingBar(totalPrice) {
  const fill = document.getElementById('shipping-bar-fill');
  const msg  = document.getElementById('shipping-bar-msg');
  if (!fill || !msg) return;

  const threshold = 8500;
  const pct       = Math.min((totalPrice / threshold) * 100, 100);
  const remaining = Math.max(threshold - totalPrice, 0);

  fill.style.width = pct + '%';

  if (totalPrice >= threshold) {
    msg.innerHTML = `<div class="flex items-center gap-1.5">
      <span class="material-symbols-outlined text-primary text-[15px]" style="font-variation-settings:'FILL' 1;">local_shipping</span>
      <p class="font-body text-xs font-bold text-primary">You've unlocked free shipping!</p>
    </div>`;
  } else {
    msg.innerHTML = `<p class="font-body text-xs text-on-surface-variant">
      <span class="font-bold text-on-surface">${formatMoney(remaining)}</span> away from free shipping
    </p>`;
  }
}

// ─── Product image switcher ───
function switchImage(src, thumbEl) {
  const mainImg = document.getElementById('main-img');
  if (!mainImg) return;
  mainImg.classList.add('switching');
  setTimeout(() => {
    mainImg.src = src;
    mainImg.classList.remove('switching');
  }, 350);
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  if (thumbEl) thumbEl.classList.add('active');
}

// ─── Option card selector (pack size, etc.) ───
function selectOption(id, price) {
  document.querySelectorAll('.option-card').forEach(c => c.classList.remove('selected'));
  const el = document.getElementById(id);
  if (el) el.classList.add('selected');
  const priceEl = document.getElementById('cta-price');
  if (priceEl) priceEl.textContent = price;
}

// ─── Variant selector ───
function initVariantSelector() {
  const variantData = document.getElementById('variant-data');
  if (!variantData) return;

  const variants = JSON.parse(variantData.textContent);

  document.querySelectorAll('.variant-option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const optionIndex = btn.dataset.optionIndex;
      // Deselect siblings
      document.querySelectorAll(`.variant-option-btn[data-option-index="${optionIndex}"]`).forEach(b => {
        b.classList.remove('border-primary', 'bg-white');
        b.classList.add('border-transparent');
      });
      // Select this one
      btn.classList.add('border-primary', 'bg-white');
      btn.classList.remove('border-transparent');

      updateSelectedVariant(variants);
    });
  });
}

function updateSelectedVariant(variants) {
  const selectedOptions = [];
  const optionGroups = document.querySelectorAll('[data-option-index]');
  const numOptions = new Set([...optionGroups].map(el => el.dataset.optionIndex)).size;

  for (let i = 0; i < numOptions; i++) {
    const selected = document.querySelector(`.variant-option-btn[data-option-index="${i}"].border-primary`);
    if (selected) selectedOptions.push(selected.dataset.value);
  }

  const variant = variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (variant) {
    const variantInput = document.getElementById('variant-id');
    if (variantInput) variantInput.value = variant.id;

    // Update price display
    const priceEl = document.getElementById('cta-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Update availability
    const btn = document.getElementById('add-to-cart-btn');
    if (btn) {
      btn.disabled = !variant.available;
      if (!variant.available) {
        btn.textContent = 'Sold Out';
      }
    }

    // Update main image if variant has an image
    if (variant.featured_image) {
      const mainImg = document.getElementById('main-img');
      if (mainImg) {
        mainImg.classList.add('switching');
        setTimeout(() => {
          mainImg.src = variant.featured_image.src;
          mainImg.classList.remove('switching');
        }, 350);
      }
    }
  }
}

// ─── Subscription / selling plan selector ───
function initSubscriptionSelector() {
  const purchaseCards = document.querySelectorAll('.purchase-type-card');
  if (!purchaseCards.length) return;

  purchaseCards.forEach(card => {
    card.addEventListener('click', () => {
      purchaseCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');

      const sellingPlanInput = document.getElementById('selling-plan-id');
      const sellingPlanId = card.dataset.sellingPlanId;

      if (sellingPlanInput) {
        if (sellingPlanId) {
          sellingPlanInput.value = sellingPlanId;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }

      // Update price display
      const priceEl = document.getElementById('cta-price');
      const displayPrice = card.dataset.price;
      if (priceEl && displayPrice) priceEl.textContent = displayPrice;
    });
  });
}

// ─── Flavour selector (electrolyte) ───
function selectFlavor(btn) {
  document.querySelectorAll('.flavor-btn').forEach(b => {
    b.classList.remove('active');
  });
  btn.classList.add('active');

  const nameEl = document.getElementById('flavor-name');
  if (nameEl) nameEl.textContent = btn.dataset.flavor;

  const img = btn.dataset.img;
  if (img) switchImage(img, null);
}
